import styled from "styled-components";
const Input = styled.input`
 padding: 0.5em;
 margin: 0.5em;
 border: none;
 width: calc(100% - 2em);
 border-radius: 10px;
 background-color: #749db3;
`;
export { Input };
